module.exports = __webpack_public_path__ + "static/media/InnovateIcon.deacc914.svg";